import { render, staticRenderFns } from "./ModalImemento.vue?vue&type=template&id=4534f924&"
import script from "./ModalImemento.vue?vue&type=script&lang=js&"
export * from "./ModalImemento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports